/*
 *  Copyright (c) 2021.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

export interface Balance {

  priceType?: string;
  debt?: number;
  expiredDebt?: number;
  totalDebt?: number;
  totalExpiredDebt?: number;
  creditLimit?: number;
  expiredDays?: number;
  description?: number;
  paymentDate?: Date;
}
